import { useEffect, useRef } from 'react';
import bem from '../../../utils/bem';
import Icon from '../../Atoms/Icon/Icon';
import FormField from '../../Atoms/FormComponents/FormField';
import GooglePlacesAuto from '../../Molecules/GooglePlacesAuto';
import FilterAccordion from '../../Atoms/FormComponents/FilterAccordion';
import { getZipFromGAddress } from '../../../utils/analitic.utils';
import { useAnalyticsPushEvent } from '../../../analytic/analytic.context';

import scrollTo from '../../../utils/scrollTo';

const SidebarFilters = ({
  formConfig,
  filtersActive,
  setFiltersActive,
  state,
  setState,
  clearAllCallback,
  searchCallback,
  blockLabel = Drupal.t('Filters'),
  clearAllBottom,
  hideLocation,
  defaultLocation,
  setSelectedLocation,
  toggleableFilters,
  filtersAnalyticsData,
}) => {
  const pushAnalyticEvent = useAnalyticsPushEvent();
  const sidebarRef = useRef(null);
  const filtersRef = useRef(null);
  const baseClass = 'sidebar-filters';

  useEffect(() => {
    scrollTo(0, 0, sidebarRef.current, 'auto');
    scrollTo(0, 0, filtersRef.current, 'auto');
  }, [filtersActive]);

  clearAllCallback =
    typeof clearAllCallback === 'function'
      ? clearAllCallback
      : () => {
          setState({});
        };

  const onLocationChangeHandler = (l, field) => {
    if (!l) return;

    const lat = l[0].geometry.location.lat();
    const lng = l[0].geometry.location.lng();
    setSelectedLocation(l);
    setState((prev) => ({
      ...prev,
      location: `${lat}, ${lng}`,
    }));

    if (filtersAnalyticsData?.event === 'list_filtered') {
      const zip = getZipFromGAddress(l);
      pushAnalyticEvent({
        ...filtersAnalyticsData,
        zip_code: zip,
        filter_name: field.label,
        filter_value: l[0].formatted_address,
      });
    }
  };

  const onDistanceChangeHandler = (r, field) => {
    setState((prev) => ({ ...prev, radius: Number(r) }));
    if (filtersAnalyticsData?.event === 'list_filtered') {
      pushAnalyticEvent({
        ...filtersAnalyticsData,
        filter_name: 'location_range',
        filter_value: field.options.find((value) => value.value === r).label,
      });
    }
  };
  return (
    <div
      ref={sidebarRef}
      className={bem(
        baseClass,
        [toggleableFilters && !filtersActive ? 'hidden' : ''],
        '',
      )}
      style={{ display: filtersActive ? 'flex' : '' }}
    >
      <div
        className={bem('header', [], baseClass, [
          'flex',
          'justify-between',
          'items-center',
        ])}
      >
        <h5>{blockLabel}</h5>
        <div className={`hidden${!clearAllBottom ? ' lg-block' : ''}`}>
          <button
            className={bem('clear-button', [], baseClass, ['btn-icon'])}
            onClick={clearAllCallback}
          >
            {Drupal.t('Clear all')}
          </button>
        </div>
        <div className="lg-hidden">
          <button
            className={bem('close-button', [], baseClass, ['btn-icon'])}
            onClick={() => setFiltersActive(false)}
          >
            <span className="visually-hidden">
              {Drupal.t('Close Filters modal')}
            </span>
            <Icon iconName="close-thin" />
          </button>
        </div>
      </div>

      <div className={bem('filters', [], baseClass)} ref={filtersRef}>
        {formConfig.map((field) => {
          if (defaultLocation) {
            field.inputDefaultValue =
              field.inputDefaultValue || defaultLocation;
          }

          if (field.type === 'geolocation' && !hideLocation) {
            if (field.wrapInAccordion) {
              return (
                <FilterAccordion
                  label={field.label}
                  mods={['overflow-visible']}
                  key={`${field.type}-${field.name}`}
                >
                  <GooglePlacesAuto
                    distanceOptions={field.options}
                    onPlaceSelected={(p) => onLocationChangeHandler(p, field)}
                    onDistanceChange={(d) => onDistanceChangeHandler(d, field)}
                    inputDefaultValue={defaultLocation}
                    selectedDistance={state?.radius}
                  />
                </FilterAccordion>
              );
            }
            return (
              <GooglePlacesAuto
                distanceOptions={field.options}
                onPlaceSelected={(p) => onLocationChangeHandler(p, field)}
                onDistanceChange={(d) => onDistanceChangeHandler(d, field)}
                inputDefaultValue={defaultLocation}
                selectedDistance={state?.radius}
              />
            );
          }
          if (field.type === 'checkboxes' && !field.options.length) {
            return null;
          }
          return (
            <FormField
              fieldConfig={field}
              state={field.state || state}
              setState={field.setState || setState}
              key={`${field.type}-${field.name}`}
              searchCallback={searchCallback}
              analyticsData={filtersAnalyticsData}
              isFacet
              forceTabletViewAll
            />
          );
        })}
      </div>

      {clearAllBottom && (
        <div
          className={bem('clear-bottom', [], baseClass, ['hidden lg-block'])}
        >
          <button className="btn btn--secondary" onClick={clearAllCallback}>
            {Drupal.t('Clear All')}
          </button>
        </div>
      )}

      <div className={bem('footer', [], baseClass, ['grid', 'lg-hidden'])}>
        <button className="btn" onClick={() => setFiltersActive(false)}>
          {Drupal.t('APPLY')}
        </button>
        <button className="btn btn--secondary" onClick={clearAllCallback}>
          {Drupal.t('CLEAR')}
        </button>
      </div>
    </div>
  );
};

export default SidebarFilters;
